import React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import createPlotlyComponent from 'react-plotly.js/factory'
import Plotly from 'plotly.js-basic-dist-min'

const Plot = createPlotlyComponent(Plotly)

const HOURS = Array.from({ length: 18 }, (_, i) => 6 + i) // 06..23
const WEEKDAYS = ['Ma', 'Ti', 'Ke', 'To', 'Pe', 'La', 'Su']

// data: { categories: [{ category, matrix: [[number per hour] per weekday], unit: '%' | 'h' }, ...] }
const OccupancyHeatmapCard = ({ title = 'Lukujärjestys (varausaste %)', data, loading }) => {
  const categories = (data && data.categories) || []
  const hasData = categories.length > 0 && categories.some((c) => Array.isArray(c.matrix) && c.matrix.flat().some((v) => v > 0))

  return (
    <Card sx={{ borderRadius: 2, height: '100%' }}>
      <CardContent sx={{ p: '12px 14px', '&:last-child': { pb: '12px' } }}>
        <Typography variant='caption' sx={{ color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.3 }}>
          {title}
        </Typography>
        {loading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 240 }}>
            <CircularProgress size={20} />
          </Box>
        ) : !hasData ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 240, color: 'text.secondary', fontSize: 12, textAlign: 'center', px: 2 }}>
            Tuntikohtainen "lukujärjestys"-näkymä vaatii backend-päivityksen<br />
            (uusi raportti hour × weekday × category).<br />
            Tieto ilmestyy heti, kun palvelin lähettää sen.
          </Box>
        ) : (
          <Box>
            {categories.map((c) => (
              <Box key={c.category} sx={{ mt: 1 }}>
                <Typography variant='caption' sx={{ color: 'text.primary', fontWeight: 600 }}>
                  {(c.category || '—').toLocaleUpperCase('fi-FI')}
                </Typography>
                <Plot
                  data={[
                    {
                      x: HOURS.map((h) => `${String(h).padStart(2, '0')}:00`),
                      y: WEEKDAYS,
                      z: c.matrix,
                      type: 'heatmap',
                      colorscale: [
                        [0, '#f1f8e9'],
                        [0.5, '#a5d6b3'],
                        [1, '#0b8043'],
                      ],
                      hovertemplate: '%{y} %{x}: %{z:,.0f} ' + (c.unit || '%') + '<extra></extra>',
                      showscale: true,
                    },
                  ]}
                  layout={{
                    autosize: true,
                    height: 180,
                    margin: { l: 40, r: 12, t: 4, b: 30 },
                    xaxis: { tickfont: { size: 10, color: '#5f6368' } },
                    yaxis: { tickfont: { size: 10, color: '#5f6368' }, autorange: 'reversed' },
                    paper_bgcolor: 'transparent',
                    plot_bgcolor: 'transparent',
                  }}
                  config={{ displayModeBar: false, responsive: true }}
                  style={{ width: '100%', height: 180 }}
                  useResizeHandler
                />
              </Box>
            ))}
          </Box>
        )}
      </CardContent>
    </Card>
  )
}

export default OccupancyHeatmapCard
